module.exports = __webpack_public_path__ + "static/img/wall-conveyor-x3-steel_64.79c97e9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/wall-conveyor-x3-steel_64.png
// module id = h+KN
// module chunks = 0